import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import StadoPayrollFooter from "./StadoPayrollFooter";
import { Link } from "react-router-dom";
export default function BookADemo() {

  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
    companyName: "",
    preferredDate: "",
    preferredTime: "",
    requirements: "",
  });

  const [status, setStatus] = useState({ type: "", message: "" });
  const [loading, setLoading] = useState(false);
  const backend = process.env.REACT_APP_API;


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus({ type: "", message: "" });

    try {
      const response = await fetch(`${backend}/book-demo`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setStatus({ type: "success", message: "Demo booked successfully!" });
        setFormData({
          name: "",
          mobile: "",
          email: "",
          companyName: "",
          preferredDate: "",
          preferredTime: "",
          requirements: "",
        });
      } else {
        throw new Error("Failed to submit");
      }
    } catch (err) {
      setStatus({ type: "error", message: "Something went wrong. Please try again later." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <style>{`
        .glass-card {
          background: rgba(255, 255, 255, 0.03);
          backdrop-filter: blur(20px);
          border: 1px solid rgba(255, 255, 255, 0.08);
          box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
        }

        .shimmer-btn {
          position: relative;
          overflow: hidden;
        }

        .shimmer-btn::after {
          content: "";
          position: absolute;
          top: -50%;
          left: -60%;
          width: 20%;
          height: 200%;
          background: rgba(255, 255, 255, 0.2);
          transform: rotate(30deg);
          transition: all 0.6s cubic-bezier(0.19, 1, 0.22, 1);
        }

        .shimmer-btn:hover::after {
          left: 120%;
        }

        input[type="date"]::-webkit-calendar-picker-indicator,
        input[type="time"]::-webkit-calendar-picker-indicator {
          filter: invert(1) opacity(0.5);
          cursor: pointer;
        }

        .highlight-pink {
          background: linear-gradient(90deg, #ff3b69, #ff914d);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
      }

      .form-text {
  color: #d1d5db;
}
      `}</style>


      <section className="relative bg-[#050505] text-gray-200 py-20 px-4 overflow-hidden font-sans min-h-screen flex flex-col items-center justify-center">

        {/* Top Center Logo */}
        <div className="absolute top-10 left-1/2 -translate-x-1/2 z-20">
          <Link to="/">
            <img
              src="/logo-dark.png"
              alt="Stado Logo"
              className="w-28 md:w-32 drop-shadow-[0_0_20px_rgba(253,44,85,0.6)] cursor-pointer"
            />
          </Link>
        </div>

        {/* Background Decorative Elements */}
        <div className="absolute top-1/4 -left-20 w-[500px] h-[500px] bg-[#f68c51]/10 blur-[140px] rounded-full animate-pulse" />
        <div
          className="absolute bottom-1/4 -right-20 w-[500px] h-[500px] bg-[#fd2c55]/10 blur-[140px] rounded-full animate-pulse"
          style={{ animationDelay: "2s" }}
        />

        <div className="relative max-w-4xl mx-auto w-full z-10 mt-24">

          {/* Header Section */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center mb-10"
          >
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 tracking-tight">
              Book a{" "}

              <span className="highlight-pink">
                Demo
              </span>
            </h1>
            <p className="text-gray-400 text-base md:text-lg max-w-xl mx-auto leading-relaxed">
              Experience the future of payroll automation.<br />
              Schedule a personalized walkthrough with our product experts.
            </p>
          </motion.div>

          {/* Glass Form Card */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="glass-card p-8 md:p-12 rounded-[3rem]"
          >
            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6 form-text">
                {[
                  { label: "Full Name", key: "name", type: "text" },
                  { label: "Work Email", key: "email", type: "email" },
                  { label: "Mobile Number", key: "mobile", type: "tel" },
                  { label: "Company Name", key: "companyName", type: "text" },
                  { label: "Preferred Date", key: "preferredDate", type: "date" },
                  { label: "Preferred Time", key: "preferredTime", type: "time" },
                ].map((field) => (
                  <div key={field.key} className="flex flex-col space-y-2">
                   <label className="text-[11px] font-semibold text-gray-400 uppercase tracking-widest ml-1">
                      {field.label}
                    </label>
                    <input
                      required
                      type={field.type}
                      value={formData[field.key]}
                      onChange={(e) =>
                        setFormData({ ...formData, [field.key]: e.target.value })
                      }
                      className="bg-white border border-gray-300 rounded-xl px-5 py-4 focus:border-[#f68c51] outline-none transition-all text-black placeholder:text-gray-500"
                    />
                  </div>
                ))}

                <div className="md:col-span-2 flex flex-col space-y-2">
                  <label className="text-[11px] font-semibold text-gray-500 uppercase tracking-widest ml-1">
                    Special Requirements
                  </label>
                  <textarea
                    rows="2"
                    value={formData.requirements}
                    onChange={(e) =>
                      setFormData({ ...formData, requirements: e.target.value })
                    }
                    className="bg-white border border-gray-300 rounded-xl px-5 py-4 focus:border-[#f68c51] outline-none transition-all text-black resize-none placeholder:text-gray-500"
                  />
                </div>
              </div>

              {/* Status Message */}
              <AnimatePresence>
                {status.message && (
                  <motion.div
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    className={`p-4 rounded-xl text-center text-sm ${status.type === "success"
                      ? "text-green-400 bg-green-500/10"
                      : "text-red-400 bg-red-500/10"
                      }`}
                  >
                    {status.message}
                  </motion.div>
                )}
              </AnimatePresence>

              {/* Submit Button */}
              <motion.button
                whileTap={{ scale: 0.98 }}
                disabled={loading}
                type="submit"
                className="shimmer-btn w-full py-5 rounded-2xl bg-gradient-to-r from-[#f68c51] to-[#fd2c55] text-white font-bold text-lg shadow-2xl transition-all"
              >
                {loading ? "Processing..." : "Schedule Demo Now"}
              </motion.button>
            </form>
          </motion.div>
        </div>
      </section>

      <StadoPayrollFooter />
    </>
  );
}
